import { MeasurementName } from '@quromedical/models';

type Meta = {
  lowConfidence?: true;
};

type GetSupplementaryMetaData = (value: number | string) => Meta;

const getSpotCheckLowConfidence: GetSupplementaryMetaData = (value) => {
  const lowConfidenceValues = ['0', '-1', 0, -1];
  const isLowConfidence = lowConfidenceValues.includes(value);

  if (!isLowConfidence) {
    return {};
  }

  return {
    lowConfidence: true,
  };
};

type SupplementaryMetaMap = Partial<
  Record<MeasurementName, GetSupplementaryMetaData>
>;

/**
 * Currently this does not account for the fact that we could have different devices for the same message.
 */
const supplementaryMetaMap: SupplementaryMetaMap = {
  [MeasurementName.SystolicArterialBloodPressure]: getSpotCheckLowConfidence,
  [MeasurementName.DiastolicArterialBloodPressure]: getSpotCheckLowConfidence,
  [MeasurementName.MeanArterialBloodPressure]: getSpotCheckLowConfidence,
  [MeasurementName.OxygenSaturation]: getSpotCheckLowConfidence,
  [MeasurementName.HeartRate]: getSpotCheckLowConfidence,
  [MeasurementName.PerfusionIndex]: getSpotCheckLowConfidence,
};

interface Measurement {
  measurementName: MeasurementName;
  value: number | string;
  meta?: Meta;
}

export const getMetadata = (record: Measurement) => {
  const getSupplementaryMetaData = supplementaryMetaMap[record.measurementName];

  if (!getSupplementaryMetaData) {
    return {};
  }

  return getSupplementaryMetaData(record.value);
};

export const isValidReading = (record: Measurement): boolean => {
  const metadata = getMetadata(record);
  const isLowConfidence = metadata.lowConfidence || record.meta?.lowConfidence;

  return !isLowConfidence;
};
